// 资质宝-资质预警相关API接口
import request from '@/utils/request'

// 查询该用户绑定的企业的所有资质信息
export const companyCertificateAllList = params => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_CERTTREASURE + '/api/dynamicCertWaringEntrust/queryEnterpriseCertificate',
		method: 'get',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		params
	})
}

// 插入预警委托信息
export const saveQualificationAlert = data => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_CERTTREASURE + '/api/dynamicCertWaringEntrust/saveQualificationAlert',
		method: 'post',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		data
	})
}

// 查询预警委托信息
export const queryQualificationAlert = params => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_CERTTREASURE + '/api/dynamicCertWaringEntrust/queryQualificationAlert',
		method: 'get',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		params
	})
}

// 取消预警委托信息
export const deleteQualificationAlert = data => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_CERTTREASURE + '/api/dynamicCertWaringEntrust/deleteQualificationAlert',
		method: 'post',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		data
	})
}

// 新增修改预警提醒规则
export const saveOrUpdateAlertMessageRules = data => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_CERTTREASURE + '/api/iCertWaringConfig/saveOrUpdate',
		method: 'post',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		data
	})
}

// 查询预警提醒规则
export const queryAlertMessageRules = params => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_CERTTREASURE + '/api/iCertWaringConfig/queryMessageRules',
		method: 'get',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		params
	})
}

// 查询临期记录（临期提醒）
export const queryTemporaryLog = params => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_CERTTREASURE + '/api/dynamicCertExpiredWaring/queryTemporaryLog',
		method: 'get',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		params
	})
}

// 查询企业提醒列表（注销、注册、风险）
export const queryCompanyWarnginList = params => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_CERTTREASURE + '/api/companyWaring/queryCompanyWarningList',
		method: 'get',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		params
	})
}

// 查询未读临期证书记录数量
export const queryUnreadTemporaryLogCount = params => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_CERTTREASURE + '/api/dynamicCertExpiredWaring/queryUnReadNum',
		method: 'get',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		params
	})
}

// 临期记录已读
export const readTemporaryLog = params => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_CERTTREASURE + '/api/dynamicCertExpiredWaring/readCertExpiredWaring',
		method: 'get',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		params
	})
}

// 查询未读企业提醒记录数量
export const queryUnreadCompanyWarnginListCount = params => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_CERTTREASURE + '/api/companyWaring/queryUnReadNum',
		method: 'get',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		params
	})
}

// 企业提醒已读
export const readCompanyWarngin = params => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_CERTTREASURE + '/api/companyWaring/readCompanyWaring',
		method: 'get',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		params
	})
}
